import React, { FC } from "react";
import {
  Typography,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { green } from "@mui/material/colors";
import { Done as DoneIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import useDeliveryMarkupSelector from "./useDeliveryMarkupSelector";
import CrateFreightMarkup from "../CrateFreightMarkup/CrateFreightMarkup";

const StyledColDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  padding: 20,
  margin: 20,
});

const StyledAcctText = styled(Typography)({
  textDecoration: "underline",
  paddingBottom: 20,
  fontWeight: "bold",
  alignSelf: "center",
  paddingTop: 80,
});

const StyledCircularProgress = styled(CircularProgress)({
  color: green[500],
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-12px",
  marginLeft: "-12px",
});

interface DeliveryMarkupProps {
  deliveryMarkup: string;
  crateFreightMarkup: string;
  changeDeliveryMarkup: (e: React.ChangeEvent<HTMLInputElement>) => void;
  changeCrateFreightMarkup: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DeliveryMarkup: FC<DeliveryMarkupProps> = ({
  deliveryMarkup,
  crateFreightMarkup,
  changeDeliveryMarkup,
  changeCrateFreightMarkup
}) => {
  const { handleButtonClick, buttonSx, loading, success } =
    useDeliveryMarkupSelector(deliveryMarkup);

  return (
    <>
      <StyledColDiv style={{ height: 350, justifyContent: "center" }}>
        <StyledAcctText variant="h4">Account Settings</StyledAcctText>

        <Typography>
          Do you want to add mark-up/margin to jobsite delivery charge?
        </Typography>

        <FormControl style={{ marginTop: 10 }}>
          <RadioGroup value={deliveryMarkup} onChange={changeDeliveryMarkup}>
            <FormControlLabel value="No" control={<Radio />} label="No" />
            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
          </RadioGroup>
        </FormControl>

        <Box sx={{ m: 1, position: "relative", marginTop: 5 }}>
          <Button
            variant="contained"
            sx={buttonSx}
            disabled={loading}
            onClick={handleButtonClick}
            startIcon={success && <DoneIcon />}
          >
            Apply
          </Button>
          {loading && <StyledCircularProgress size={24} />}
        </Box>
      </StyledColDiv>

      <CrateFreightMarkup
        crateFreightMarkup={crateFreightMarkup}
        changeCrateFreightMarkup={changeCrateFreightMarkup}
      />
    </>
  );
};

export default DeliveryMarkup;
